import { render, staticRenderFns } from "./SlideNav.vue?vue&type=template&id=e6066050"
import script from "./SlideNav.vue?vue&type=script&lang=ts"
export * from "./SlideNav.vue?vue&type=script&lang=ts"
import style0 from "./SlideNav.vue?vue&type=style&index=0&id=e6066050&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports